import { task, collated } from './helpers';
import OrdersAPI from 'api/orders';

export class Orders {
	@task
	@collated
	fetchOrderStatus({ start_date, end_date, view_by }) {
		return OrdersAPI.fetchOrderStatus(start_date, end_date, view_by);
	}

	@task
	fetchOrderDetails(orderNumber) {
		return OrdersAPI.fetchOrderDetails(orderNumber);
	}

	@task
	fetchOrderProducts(orderNumber, pagination) {
		return OrdersAPI.fetchOrderProducts(orderNumber, pagination);
	}

	@task
	fetchPartNumber(searchItemNumber, pagination) {
		return OrdersAPI.fetchPartNumber(searchItemNumber, pagination);
	}
}

export default new Orders();



// WEBPACK FOOTER //
// ./src/state/Orders.js